(ns practitest.frontend.reports.utils)

(defn chartable-field? [field]
  (boolean (#{"list" "linkedlist" "user"} (:type field))))

(defn default-fields [cvs]
  (let [fields (->> cvs first last)]
    (vec (if (some #(= "id" %) fields) fields (cons "id" fields)))))

(defn fields-map [field-defs]
  (->> field-defs
       (map #(vector (:field %) %))
       (into {})))

(defn chart-fields [fields-map fields]
  (->> fields
       (map #(get fields-map %))
       (filter chartable-field?)
       (map :field)))

 (defn run-filter-by-criteria-pvs [fields run-filter-by]
   ; fields can be: [["___f_240","my list",["list val 3","list val 2","list val 1","amir"]],["___f_252","list2","list",["ccc","bbb","aaa"]]]
   ; run-filter-by can be: ___f_240
   ; return will be the pvs of the field: ["list val 3","list val 2","list val 1","amir"]
   (last (last (filter (fn [field] (= run-filter-by (first field))) fields))))
